<router-outlet (activate)="activated = true"></router-outlet>

<hfc-spinner *ngIf="!activated"></hfc-spinner>

<hfc-toast></hfc-toast>
<hfc-dialog></hfc-dialog>
